import Vue from "vue";
import Vuex, { Store, StoreOptions } from "vuex";
import { getField } from "vuex-map-fields";

import {
    RootState,
    Forsteg,
    Kontaktuppgifter,
    Observationer,
    Utomlands,
    AssistansErsattning,
    AnnatMisstanke,
    StatligtTandvardsstod,
    ForetagGenerell,
    PrivatpersonGenerell,
} from "./types";
import { mutations } from "./mutations";

Vue.use(Vuex);

export function getNewState(): RootState {
    const forsteg: Forsteg = {
        vilkenroll: null,
        misstanke: null,
    };
    const kontaktuppgifter: Kontaktuppgifter = {
        anmalareVarJobbar: "",
        anmalareDittFornamn: "",
        anmalareDittEfternamn: "",
        anmalareDinTelefon: "",
        anmalareKontaktuppgift: "",
        anmalareOvrigKontaktuppgift: "",
        anmalareRelationTill: "",
        anmaldAdressOrt: "",
        anmaldAndraUppgifter: "",
        anmaldFodelsedatum: "",
        anmaldFornamn: "",
        anmaldEfternamn: "",
        anmaldPersonnummer: "",
        anmaldKontaktuppgift: "",
        ovrigaUppgifter: "",
        vetPersonnummer: "",
        villDuVaraAnonym: null,
        foretagNamn: "",
        foretagForetradare: "",
        foretagOvrigaUppgifter: "",
        organisationsnummer: "",
    };
    const utomlands: Utomlands = {
        bostadSverige: "",
        flyttaTillbaka: "",
        narSkeddeFlytten: "",
        hurVetDu: "",
        utomlandsVistelsen: "",
        vilketLand: "",
    };
    const foretagGenerell: ForetagGenerell = {
        medvetetFel: null,
        vadGorDetMedvetet: "",
        beskrivSituationen: "",
        hurVetDuAtt: "",
        lamnaUppgifterSomStodjer: "",
    };
    const privatpersonGenerell: PrivatpersonGenerell = {
        medvetetFel: null,
        varforTrorDuDet: "",
    };
    const assistansErsattning: AssistansErsattning = {
        assistansErsattningVal: null,
        berattaOmAssistansen: "",
        vadFarPersonenHjalpMed: "",
        assistansTidInteArbetar: "",
        assistansTidAnnanSysselsattning: "",
        assistansErsattningEjBehov: "",
        ekonomiskaOegentligheter: "",
        andraPersoner: "",
        beskrivOvrigaSkal: "",
        hurLange: "",
        ovrigInformation: "",
        uppgifterForsakringskassan: "",
    };
    const annatMisstanke: AnnatMisstanke = {
        hurLangeFelUtbetalt: "",
        inteRattTillErsattning: "",
    };
    const statligtTandvardsstod: StatligtTandvardsstod = {
        beskrivSituationen: "",
        fleraEllerSpeciellaBesok: "",
        narGjordesBesoken: "",
        namnPaTandlakare: "",
        namnPaMottagning: "",
    };
    const observationer: Observationer = {
        situation: null,
        typAvErsattning: "",
        vadStammerInPaPersonen: null,
        anmaldArbete: "",
        anmaldArbeteAdress: "",
        anmaldBeskrivArbete: "",
        anmaldHurOftaArbetar: "",
        anmaldHurVetDu: "",
        anmaldBeskrivForetag: "",
        anmaldForetagIntressenter: "",
        anmaldInsynIVerksamheten: "",
        ensamstaendeAdress: "",
        ensamstaendeHurVetDu: "",
        ensamstaendeHurLange: "",
        ensamstaendeFornamn: "",
        ensamstaendeEfternamn: "",
        ensamstaendeUppgifterSambo: "",
        ensamstaendeOvrigaBostader: "",
        bilagor: "",
        utomlands,
        assistansErsattning,
        annatMisstanke,
        statligtTandvardsstod,
        foretagGenerell,
        privatpersonGenerell,
        underrattelseskyldighet: null,
        files: [],
    };
    const state: RootState = {
        forsteg: forsteg,
        kontaktuppgifter: kontaktuppgifter,
        observationer: observationer,
    };
    return state;
}

export function getStore(): Store<RootState> {
    const store: StoreOptions<RootState> = {
        state: getNewState(),
        mutations,
        getters: {
            getField,
        },
    };
    return new Store<RootState>(store);
}

export const store = getStore();
